import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Semaforo from "./Semaforo";
import HelpFraudChartDialog from "./HelpFraudChartDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(5),
    display: "flex",
    gap: theme.spacing(2),
    justifyContent: "center",
  },
  light: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "green",
    marginRight: theme.spacing(2),
  },
  infoBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },
  info: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  bottomInfo: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: ".8rem",
    // [theme.breakpoints.down("sm")]: {
    //   flexDirection: "row",
    // },
  },
}));

const FraudLight = ({ data }) => {
  const [percentage, setPercentage] = useState(0);
  const [color, setColor] = useState("green");

  const classes = useStyles();

  useEffect(() => {
    if (data) {
      const { streamsByPeriod, fraudLight } = data;

      // FRAUDULENT DATA
      const totalFraudulent = fraudLight.totalFraudulent || 0;

      // LEGAL STREAMS DATA
      const totalStreamsCount = streamsByPeriod
        .filter((p) => fraudLight.periods.includes(p.period))
        .reduce((acc, curr) => acc + curr.cantidad, 0);

      // Ensure we have at least 1 to avoid division by zero
      const maxAllowedFraud = Math.max(1, Math.round(totalStreamsCount * 0.01));

      let percentageNumber = 0;
      if (totalFraudulent > 0 && maxAllowedFraud > 0) {
        percentageNumber = parseFloat(
          (totalFraudulent / maxAllowedFraud) * 100
        );
        // Cap the percentage at 100 if needed
        percentageNumber = Math.min(percentageNumber, 100);
      }

      setPercentage(isNaN(percentageNumber) ? 0 : percentageNumber);

      let newColor = "green";
      if (percentageNumber > 30) newColor = "yellow";
      if (percentageNumber > 50) newColor = "red";
      setColor(newColor);
    }
  }, [data]);
  return (
    <div className={classes.root}>
      <div className={classes.infoBox}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
            gap: "0.5em",
            // minWidth: "300px",
            // background: "yellow",
          }}
        >
          <Typography variant="h3" style={{ fontWeight: "bold" }}>
            {percentage.toFixed(0)}%
          </Typography>
          <Typography variant="body1">del máximo tolerable</Typography>
        </div>

        <Semaforo color={color} />

        <div className={classes.bottomInfo}>
          <Typography variant="body1" color="textSecondary">
            🙏🏽 {""}
            <a
              href="https://artists.spotify.com/es-419/artificial-streaming"
              target="_blank"
            >
              Todo lo que debes saber
            </a>
          </Typography>
          <Typography variant="body1" color="textSecondary">
            👉🏾{" "}
            <a href="https://www.artist.tools/bot-checker" target="_blank">
              Entender de dónde viene
            </a>
          </Typography>

          <HelpFraudChartDialog />
        </div>
      </div>
    </div>
  );
};

export default FraudLight;
